module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-body"
  }, [(!_vm.disable) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Adiciona um usuário",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Oculta usuários sem acesso ao sistema ou mostra todos os usuários",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.inativosOcultados = !_vm.inativosOcultados
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.inativosOcultados ? 'Mostrar Inativos' : 'Somente Ativos'))])]), _vm._v(" "), (_vm.mostraInclusao === true && _vm.mostraInclusao) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_insercao",
    attrs: {
      "title": '<h5>Inclusões: ' + _vm.inclUsuTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a inserção de novo(s) usuario(s)")])])]) : _vm._e(), _vm._v(" "), (_vm.mostraExclusao === true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        placement: 'right',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', placement : 'right', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning indicador_exclusao",
    attrs: {
      "title": '<h5>Exclusões: ' + _vm.excUsuTexto + '</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("  Houve a exclusão de usuario(s)")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tabelaUsuarios",
    attrs: {
      "how-empty": "",
      "stacked": "md",
      "id": "usuarios-table",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "tbody-tr-class": _vm.inativosMostrarOcultar,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ds_telefone",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "ds_cpf",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]
      }
    }, {
      key: "bt_ativo",
      fn: function(row) {
        return [_c('i', {
          class: _vm.isTrue(row.value) ? 'fa fa-circle text-green' : 'fa fa-circle text-red',
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!_vm.disable) ? _c('div', [(row.item.ds_cpf !== null) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.edita(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-sm-offset-0 fa-lg"
        }, [(_vm.indiceAlt == row.index && _vm.mostraAlteracao === true && _vm.mostraInclusao === false) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'left'
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true, placement:'left' }"
          }],
          staticClass: "fa fa-warning",
          staticStyle: {
            "position": "relative",
            "top": "8px",
            "margin-left": "2px",
            "color": "#fb2916"
          },
          attrs: {
            "title": '<h5>Clique em editar para ver as mudanças.</h5>'
          }
        }) : _vm._e()])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.table.items && (_vm.table.items.length > _vm.table.perPage)) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), (_vm.state === 'FORM') ? _c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "name": "frmAddUser"
    }
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('div', {
    staticClass: "control-label col-md-2"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_nome_usuario),
      expression: "usuario.ds_nome_usuario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:100'),
      expression: "'required|min:1|max:100'"
    }],
    ref: "ds_nome_usuario",
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true || _vm.disable
    },
    domProps: {
      "value": (_vm.usuario.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_nome_usuario')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_nome_usuario + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf",
      "data-vv-as": "CPF",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true,
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.usuario.ds_cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_cpf", $$v)
      },
      expression: "usuario.ds_cpf"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_cpf')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_cpf + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('login')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "login"
    }
  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_login),
      expression: "usuario.ds_login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.usuario.ds_login)
    },
    on: {
      "change": function($event) {
        return _vm.verificaUsuario('ds_login', _vm.usuario.ds_login)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_login')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_login + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('login')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('login')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.usuario.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_telefone", $$v)
      },
      expression: "usuario.ds_telefone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_telefone')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_telefone + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_email),
      expression: "usuario.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "data-vv-as": "E-Mail",
      "type": "text",
      "disabled": _vm.bloqueioCampos === true
    },
    domProps: {
      "value": (_vm.usuario.ds_email)
    },
    on: {
      "change": function($event) {
        return _vm.verificaUsuario('ds_email', _vm.usuario.ds_email)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'ds_email')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + _vm.texto.ds_email + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('status')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.bt_ativo),
      expression: "usuario.bt_ativo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.usuario, "bt_ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-offset-2 fa-lg"
  }, [(_vm._.hasIn(_vm.mudancas, 'bt_ativo')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "fa fa-warning",
    staticStyle: {
      "position": "relative",
      "top": "8px",
      "margin-left": "2px",
      "color": "red"
    },
    attrs: {
      "title": '<h5>Conteúdo anterior: ' + (_vm.texto.bt_ativo | 'Ativo') + '</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.errors.first('status')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Status do Usuário é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-offset-2 col-md-4"
  }, [(!_vm.verificandoLoginEmail) ? _c('span', [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "uib-tooltip": "Salva o cadastro",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd(_vm.frmAddUser)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar Usuário")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back",
    attrs: {
      "type": "button",
      "uib-tooltip": "Cancela a edição"
    },
    on: {
      "click": function($event) {
        return _vm.onCancel(_vm.frmAddUser)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])]) : _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  }), _vm._v("  Verificando se já existe...\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_vm._v("Cadastre abaixo o usuário que utilizará o sistema pela entidade")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f02641a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/usuarios.vue
// module id = 1880
// module chunks = 1